import axios from 'axios';
import qs from 'qs';
import urls from '@/settings/urls';

export const GetAllPlans = (showHidden) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.plans}${showHidden ? '?show_hidden=true' : ''}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetPlan = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.plans}/${id}`
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const CreatePlan = (params) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.plans}`,
    params: {
      plan: params,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdatePlan = (params) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.plans}/${params.id}`,
    params: {
      plan: params.data,
    },
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const DeletePlan = (id) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.plans}/${id}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdatePlanOptions = (params) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.plans}/${params.id}/update_options`,
    data: params.data
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetSubscribers = (id) => {
  let requestOptions = {
    method: 'GET',
    url: `${urls.plans}/${id}/subscribers`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const AddConfRoom = (params) => {
  let requestOptions = {
    method: 'POST',
    url: `${urls.plans}/${params.planId}/conf_rooms`,
    params: params.data,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdateConfRoom = (params) => {
  let requestOptions = {
    method: 'PUT',
    url: `${urls.plans}/${params.planId}/conf_rooms/${params.roomId}`,
    params: params.data,
    paramsSerializer: params => qs.stringify(params, { arrayFormat: 'brackets' })
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const RemoveConfRoom = (params) => {
  let requestOptions = {
    method: 'DELETE',
    url: `${urls.plans}/${params.planId}/conf_rooms/${params.roomId}`
  };

  return axios(requestOptions)
    .then(res => res.data);
}

export const GetPricesList = () => {
  let requestOptions = {
    method: 'GET',
    url: urls.admin.prices_lists
  }

  return axios(requestOptions)
    .then(res => res.data);
}

export const UpdatePricesList = (data) => {
  let requestOptions = {
    method: 'POST',
    url: urls.admin.prices_lists,
    data
  }

  return axios(requestOptions)
    .then(res => res.data);
}